import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {
  cached: {},
}

export const getters = {}

export const mutations = {
  CACHE_TIME_SOFT(state, timeSoft) {
    state.cached = timeSoft
  },
}

export const actions = {
  init({ state, dispatch }) {},
  manualCreateTimeSoft(context, formData) {
    let promise = null
    promise =  axios.post(`${serverUrl}/euro_timesoft/shift_time/`, formData)
    return promise.then(
      (response) => {
        return response
      }
    )
  },
}